import type { RescheduleChargeSummary } from '@src/core/buyerApiClient';

interface Params {
  isChargedRescheduleEnabled: boolean;
  isChargeable: boolean;
  chargeSummary?: RescheduleChargeSummary;
}

export function requiresAdditionalRescheduleCharge({
  isChargedRescheduleEnabled,
  isChargeable,
  chargeSummary,
}: Params): boolean {
  if (!isChargedRescheduleEnabled) return false;
  if (!isChargeable) return false;
  if (!chargeSummary) return false;

  return chargeSummary.adjustmentAmount.amountCents > 0;
}
